import { compactResponsiveTree, mapValues } from '../compact';
import { compactBackground, compactBorder } from '../features';

/**
 * The props of a default column, storing only what says something — see
 * `compactBlockProps` for the rules; the column has the same contour and
 * background, and no per-breakpoint switches of its own to skip.
 */
export function compactColumnProps<T extends { syncWithDesktop?: boolean; border?: object; background?: object }>(
    props: T
): T {
    const compacted = mapValues(props, (value, key) => {
        if (key === 'border') return compactBorder(value as never);
        if (key === 'background') return compactBackground(value as never);

        return value;
    });

    return (props.syncWithDesktop ? compactResponsiveTree(compacted) : compacted) as T;
}
